import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../../../../_redux/advisors/AdvisorsAction";
import { resultAlert } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../../_metronic/_partials/controls";
import { StudentsFilter } from "./students-filter/StudentsFilter";
import { StudentsTable } from "./students-table/StudentsTable";
import { useStudentsUIContext } from "./StudentsUIContext";

export function StudentsCard({ 
  history,
  teacherId,
  term
}) {
  // Students Card UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      ids: studentsUIContext.ids,
      setIds: studentsUIContext.setIds,
      queryParams: studentsUIContext.queryParams
    };
  }, [studentsUIContext]);

  // Students Redux state
  const dispatch = useDispatch();
    
  /** Belli Bir Danışman Öğrenci Listesini Kaydeder */
  const saveAdvisorStudents = (ids) => {
    dispatch(actions.saveAdvisorStudents(teacherId, term, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/danisman-ogretmenler"), 2500);
  };

  const title = <>Öğrenci Listesi{studentsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{studentsUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => saveAdvisorStudents(studentsUIProps.ids)}
          >
            Kaydet
          </button>
        </CardHeaderToolbar>           
      </CardHeader>
      <CardBody>
        <StudentsFilter 
          term={term}
        />
        <StudentsTable />
      </CardBody>
    </Card>
  );
}